'use client';

import { createContext, PropsWithChildren, useCallback, useMemo, useState } from 'react';

import { RelatedDocument } from '@ravago/shared/page-data/models/elements';

export interface WidgetContextProps {
   shareDocumentList: { detailPageName: string; documents: RelatedDocument[] };
   downloadDocumentList: RelatedDocument[];
   setShareList: (documentInfo: { detailPageName: string; documents: RelatedDocument[] }) => void;
   setDownloadList: (documents: RelatedDocument[]) => void;
}

export const WidgetContext = createContext<WidgetContextProps | null>(null);

export const WidgetProvider = ({ children }: PropsWithChildren) => {
   const [shareDocumentList, setShareDocumentList] = useState<{ detailPageName: string; documents: RelatedDocument[] }>({
      detailPageName: '',
      documents: []
   });
   const [downloadDocumentList, setDownloadDocumentList] = useState<RelatedDocument[]>([]);

   const setShareList = useCallback((documentInfo: { detailPageName: string; documents: RelatedDocument[] }) => {
      setShareDocumentList(documentInfo);
   }, []);

   const setDownloadList = useCallback((documents: RelatedDocument[]) => {
      setDownloadDocumentList(documents);
   }, []);

   const widgetContext: WidgetContextProps = useMemo(
      () => ({
         shareDocumentList,
         setShareList,
         downloadDocumentList,
         setDownloadList
      }),
      [shareDocumentList, setShareList, downloadDocumentList, setDownloadList]
   );

   return <WidgetContext value={widgetContext}>{children}</WidgetContext>;
};
